import React from 'react';
import Icon from 'components/canvas/components/icon';
import { useSelectedNodeOperations } from 'state/canvas/selected-node';
import EditIcon from 'styles/icons/edit.svg';
import EditGoldIcon from 'styles/icons/edit-gold.svg';

export interface SurfaceNodeEditIconProps {
  onClick?: Function;
  width?: number;
  height?: number;
}

const defaultProps = {};

function SurfaceNodeEditIcon(props: SurfaceNodeEditIconProps) {
  const [isSelected, setSelected] = React.useState<boolean>(false);
  const { clearSelectedNode } = useSelectedNodeOperations();

  const src = isSelected ? EditGoldIcon : EditIcon;

  function onClick(event) {
    setSelected(true);
    event.cancleBubble = true;

    setTimeout(() => {
      props.onClick && props.onClick();
      clearSelectedNode();
    }, 200);
  }

  return (
    <Icon
      {...props}
      onClick={onClick}
      src={src}
      onMouseOver={() => setSelected(true)}
      onMouseOut={() => setSelected(false)}
    />
  );
}

SurfaceNodeEditIcon.defaultProps = defaultProps;

export default SurfaceNodeEditIcon;
